import React from 'react';
import { render } from 'react-dom';
import fetch from 'isomorphic-fetch';
import cookie from 'react-cookie';
import Header from './Header';
import Footer from './Footer';
import OpenHouse from './OpenHouse';
import config from '../../config/';

import './styles.scss';

const headerRoot = document.getElementById('backplane-header');
const openHouseModalRoot = document.getElementById('backplane-header-open-house');
const footerRoot = document.getElementById('backplane-footer');

const preloadedState = window.__BACKPLANE_API__; // eslint-disable-line no-underscore-dangle

const fetchBackplane = async () => {
  const accessToken = cookie.load('access_token');
  const at = accessToken ? `&accessToken=${accessToken}` : '';
  const url = `${config.servicesURL}/backplane/render.json?bundle=margins${at}`;
  const response = await fetch(url);
  const body = await response.json();

  if (response.status === 200) return body;
  throw body;
};

if (preloadedState) {
  render(<Header {...preloadedState} />, headerRoot);
  render(<Footer {...preloadedState} />, footerRoot);
  render(<OpenHouse {...preloadedState} />, openHouseModalRoot);
} else {
  fetchBackplane().then((backplane) => {
    render(<Header {...backplane.data.api} />, headerRoot);
    render(<Footer {...backplane.data.api} />, footerRoot);
    render(<OpenHouse {...backplane.data.api} />, openHouseModalRoot);
    document.dispatchEvent(new CustomEvent('backplane_loaded', {
      detail: backplane.data.api,
    }));
  });
}



// WEBPACK FOOTER //
// ./src/bundles/margins/entry.js